import React from "react"
import { getPrismicImageProps } from "src/utils/prismicImage"

const PrismicResponsiveImage = ({
  image,
  alt,
  className,
  imageClassName,
  imgixParams,
  loading = "lazy",
  sizes,
  wrapperClassName,
  widths,
}) => {
  const imageProps = getPrismicImageProps(image, {
    imgixParams,
    sizes,
    widths,
  })

  const img = (
    <img
      src={imageProps.src}
      srcSet={imageProps.srcSet}
      sizes={imageProps.sizes}
      alt={alt ?? imageProps.alt}
      className={imageClassName ?? className}
      loading={loading}
    />
  )

  if (wrapperClassName) {
    return <div className={wrapperClassName}>{img}</div>
  }

  return img
}

export default PrismicResponsiveImage
